// extracted by mini-css-extract-plugin
export var heroImg = "Home-module--heroImg--2KTli";
export var mailInputContainer = "Home-module--mailInputContainer--Px40S";
export var cardTitle = "Home-module--cardTitle--vXZHg";
export var cardBlueTitle = "Home-module--cardBlueTitle--DqJ7+";
export var cardCents = "Home-module--cardCents--sOhMh";
export var signupButton = "Home-module--signupButton--ztI8e";
export var aTagButton = "Home-module--aTagButton--gms6C";
export var aTagButtonSmall = "Home-module--aTagButtonSmall--0ebWs";